<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Codigo Original</label>
            <b-form-input v-model="codigo" placeholder="Codigo Original" @input="filter"/>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Codigo Alternativo</label>
            <b-form-input v-model="altercode" placeholder="Codigo Alterno" @input="filter"/>
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2">
            <label>Categoria</label>
            <v-select
              v-model="selectedCategory"
              :options="categories"
              label="name"
              placeholder="Categoria"
              @input="filter"
            />
          </b-col>
          <b-col md="3" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import AutopartService from '@/services/AutoParts'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      codigo: '',
      altercode: '',
      arrayFilters: [],
      selectedCategory: null,
      categories: [],
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect
  },
  mounted() {
    this.getCategories()
  },
  methods: {

    async getCategories() {
      const resp = await AutopartService.getAutoPartsCategory('', this.$store)
      if (resp) {
        this.categories = resp.data.rows
      }
    },

    async filter() {
      this.arrayFilters = [];
      if (this.codigo !== '') {
        this.arrayFilters.push({
          keyContains: 'autopart.originalCode',
          key: 'contains',
          value: this.codigo
        }); 
      }

      if (this.altercode !== '') {
        this.arrayFilters.push({
          keyContains: 'autopart.alterCode',
          key: 'contains',
          value: this.altercode
        }); 
      }

      if (this.selectedCategory) {
        this.arrayFilters.push({
          keyContains: 'autopart.autopartCategory',
          key: 'is',
          value: { id: this.selectedCategory.id }, 
        });
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.codigo = '';
      this.altercode = '';
      this.arrayFilters = [];
      this.selectedCategory = null;
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
